import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FormEvent, Fragment, useState } from "react";
import { Button, Form, InputGroup, Modal, Spinner } from "react-bootstrap";
import { ICompanyResource } from "../../models/company";
import User, { IUserResource } from "../../models/user";
import FormControlFeedback from "../FormControlFeedback";

interface Props {
  company: ICompanyResource;
  onCreated: (user: IUserResource) => void;
}

const defaultUser = {
  id: 0,
  firstName: "",
  lastName: "",
  email: "",
  isAdmin: false,
  active: false,
};
const CreateCompanyUser: React.FC<Props> = ({ company, onCreated }) => {
  const [loading, setLoading] = useState(false);
  const [shown, setShown] = useState(false);

  const [error, setError] = useState<Error | undefined>();
  const [user, setUser] = useState<IUserResource>(defaultUser);

  const saveChanges = async () => {
    try {
      setLoading(true);
      const created = await User.AddAndAssign(user, company);
      setLoading(false);
      setShown(false);
      if (onCreated) {
        onCreated(created);
      }
    } catch (error) {
      setLoading(false);
      setError(error);
      console.error(error);
    }
  };

  const formSave = async (event: FormEvent) => {
    event.preventDefault();
    await saveChanges();
  };

  return (
    <Fragment>
      <Button title="Opret bruger" onClick={() => setShown(true)}>
        <FontAwesomeIcon icon={faPlus} />
      </Button>
      <Modal show={shown} onHide={() => setShown(false)}>
        <form onSubmit={formSave}>
          <Modal.Title>Opret bruger</Modal.Title>
          <Modal.Body>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Email</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControlFeedback
                  errors={error}
                  field="email,user"
                  onChange={(value: string) =>
                    setUser({ ...user, email: value })
                  }
                />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Fornavn</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControlFeedback
                  errors={error}
                  field="quota"
                  onChange={(value: string) =>
                    setUser({ ...user, firstName: value })
                  }
                />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Efternavn</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControlFeedback
                  errors={error}
                  field="lastName"
                  onChange={(value: string) =>
                    setUser({ ...user, lastName: value })
                  }
                />
              </InputGroup>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" disabled={loading} type="submit">
              Gem {loading && <Spinner animation="border" size="sm" />}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setUser(defaultUser);
                setShown(false);
              }}
            >
              Luk
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
};

export default CreateCompanyUser;
